export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";